import React from 'react'
import ReactMarkdown from 'react-markdown'
import ClockIcon from '../../../components/icons/ClockIcon'
import { formatDate, Text } from '../../../modules/Dashboard'
import { useMainContext } from '../../../core/contexts/main'

const NotificationDetails = ({ notification, onClose }) => {
    const { main: { lang } } = useMainContext()

    if (!notification) return null

    return (
        <div className="space-y-4 text-start p-2">
            <h3 className="text-lg font-semibold text-mainColor">
                {notification.title}
            </h3>

            <ReactMarkdown className="leading-6 text-white">
                {notification.body}
            </ReactMarkdown>

            <span className="flex items-center gap-1 text-[#C27AFF] text-sm">
                <ClockIcon color="#C27AFF" size={18} />
                {formatDate(notification.createdAt, 'full', lang)}
                <Text tid="at" className="text-inherit" />
                {formatDate(notification.createdAt, 'time', lang)}
            </span>
            <button onClick={onClose} className='w-full text-center rounded-lg bg-mainColor px-3 py-2'>
                <Text tid={"close"} />
            </button>
        </div>
    )
}

export default NotificationDetails
